import React, { useState, useRef } from "react"
import { CarouselProvider, Slide } from "pure-react-carousel"

import appTheme from "appTheme"

import ArrowIcon from "images/right-arrow.svg"
import ArrowDisableIcon from "images/right-arrow-disable.svg"
import Card from "./card"
import { Container, Header, Title, Arrows, LeftArrow, RightArrow, Slider } from "./styles"

const Equipment = ({ element }) => {
  const { items } = element
  if (!items || items.length === 0) {
    return null
  }

  const [currentSlide, setCurrentSlide] = useState(0)
  const visibleSlides =
    typeof window === "undefined" || window.innerWidth <= appTheme.breakpoints.mobile
      ? 2
      : window.innerWidth < appTheme.breakpoints.hamburgerLarge
      ? 3
      : 4

  const [leftArrowDisabled, setLeftArrowDisabled] = useState(true)
  const [rightArrowDisabled, setRightArrowDisabled] = useState(items.length <= visibleSlides)
  const rightArrow = useRef()
  const leftArrow = useRef()

  const updateArrows = () => {
    setTimeout(() => {
      setRightArrowDisabled(rightArrow.current.base.disabled)
      setLeftArrowDisabled(leftArrow.current.base.disabled)
    }, 0)
  }

  const onFocus = (index) => {
    // This improves the behaviour of the carrousel traversing it with the tab key
    setCurrentSlide(index < visibleSlides ? 0 : index - visibleSlides + 1)
    updateArrows()
  }

  return (
    <Container>
      <CarouselProvider
        naturalSlideWidth={176}
        naturalSlideHeight={280}
        totalSlides={items.length}
        currentSlide={currentSlide}
        visibleSlides={visibleSlides}
      >
        <Header>
          <Title>Equipment Needed</Title>
          {items.length > visibleSlides && (
            <Arrows>
              <LeftArrow ref={leftArrow} onClick={updateArrows} disable={leftArrowDisabled}>
                <img
                  fetchpriority="low"
                  src={leftArrowDisabled ? ArrowDisableIcon : ArrowIcon}
                  alt="left"
                />
              </LeftArrow>
              <RightArrow ref={rightArrow} onClick={updateArrows} disable={rightArrowDisabled}>
                <img
                  fetchpriority="low"
                  src={rightArrowDisabled ? ArrowDisableIcon : ArrowIcon}
                  alt="right"
                />
              </RightArrow>
            </Arrows>
          )}
        </Header>
        <Slider>
          {items.map(({ image, price, name, url, source }, index) => (
            <Slide tabIndex={-1} key={`${name}`} index={index}>
              <Card
                image={image}
                price={price}
                name={name}
                url={url}
                source={source}
                index={index}
                onFocus={onFocus}
              />
            </Slide>
          ))}
        </Slider>
      </CarouselProvider>
    </Container>
  )
}

export default Equipment
